import React from 'react';
import LegalLayout, {
  LegalSection,
  LegalParagraph,
  LegalList,
  LegalNote
} from './LegalLayout';

const ChildSafeguarding = () => (
  <LegalLayout
    title="Child Safeguarding Statement"
    effectiveDate="Effective from 1 June 2026"
    pageTestId="child-safeguarding-page"
  >
    <LegalNote tone="safe">
      Every child who joins Read Right Academy has the right to learn in an
      environment that is safe, respectful, and supportive. Safeguarding is at
      the heart of how we teach.
    </LegalNote>

    <LegalSection heading="1. Our Commitment">
      <LegalParagraph>
        Read Right Academy is committed to creating a learning experience —
        online and in person — where children feel emotionally and physically
        safe. We treat every child with patience, respect, and kindness, and we
        expect every adult in the learning space to do the same.
      </LegalParagraph>
    </LegalSection>

    <LegalSection heading="2. Safe Online Classes">
      <LegalList
        items={[
          'All online classes take place on a secure video platform with class links shared only with enrolled families.',
          'A parent or guardian is expected to be at home and reachable during classes for children aged 3–6.',
          'Teachers will never ask a child to share private information, photos, or personal details outside the lesson.',
          'Class recordings, when made, are used strictly for parent review or catch-up and are not shared publicly.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="3. Communication with Children">
      <LegalParagraph>
        Communication with children always happens through their parent or
        guardian. Direct private messaging with a child outside class is not
        permitted under any circumstances.
      </LegalParagraph>
    </LegalSection>

    <LegalSection heading="4. Behaviour Expectations">
      <LegalList
        items={[
          'We do not tolerate bullying, name-calling, or any form of shaming during lessons.',
          'Teachers use calm, encouraging language — children are never pressured or rushed.',
          'If a child appears anxious or upset, the teacher will adjust the pace and inform the parent.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="5. Concerns and Reporting">
      <LegalParagraph>
        If you have any concern about your child&apos;s wellbeing during our
        programmes, please contact Kalah K. Singam directly:
      </LegalParagraph>
      <LegalList
        items={[
          'WhatsApp: +60 16-629 1687',
          'Email: teacherkalah@gmail.com'
        ]}
      />
      <LegalParagraph>
        We take every concern seriously and will respond as quickly as
        possible. In serious situations involving suspected harm to a child,
        we will cooperate fully with appropriate local authorities and child
        protection services.
      </LegalParagraph>
    </LegalSection>

    <LegalSection heading="6. Ongoing Practice">
      <LegalParagraph>
        Safeguarding is reviewed regularly. We update this statement when our
        practices evolve, and we welcome feedback from parents and educators on
        how we can do better.
      </LegalParagraph>
    </LegalSection>
  </LegalLayout>
);

export default ChildSafeguarding;
